import { render, staticRenderFns } from "./KoioteGraficoZonas.vue?vue&type=template&id=47dbf7fb&lang=es"
import script from "./KoioteGraficoZonas.vue?vue&type=script&lang=js"
export * from "./KoioteGraficoZonas.vue?vue&type=script&lang=js"
import style0 from "./KoioteGraficoZonas.vue?vue&type=style&index=0&id=47dbf7fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports